<template>

  <m-pay-layout>
    <v-layout justify-center align-top>
      <h2 id="mpay-main-page-label">Please select view.</h2>
    </v-layout>
  </m-pay-layout>

</template>

<script>

export default {
  name: 'MPayRoot',
  methods: {
    temp() {
      return 'OK';
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/MPayRoot.vue